module.exports = __webpack_public_path__ + "assets/img/16.638fe5fc.png";